<template>
  <div class="wp100 h40 dis-f mb5" style="box-sizing: border-box">
    <div
      class="h40 lh40 pl20 pr20 ta-c fs14 point"
      v-for="typeItem in typeArray"
      :class="chooseSourceId == typeItem.id ? 'chooseSource' : ''"
      @click="chooseSource(typeItem.id)"
    >
      {{ typeItem.title }}
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      chooseSourceId: 1,
    };
  },

  methods: {
    // 投稿来源点击事件
    chooseSource(sourceId) {
      this.chooseSourceId = sourceId;
      this.$emit("typeCallback", sourceId);
    },
  },

  props: {
    typeArray: Array,
  },
};
</script>

<style>
.chooseSource {
  border-bottom: 2px solid #f93e61;
  color: #f93e61;
}
</style>
